import axios from 'axios';

export async function getRSAKeyPairForCloud(wId, domainurl, sub_skill) {
  try {
    // let res = await axios.get(`/bot/api/${wId}/generateRSAKeyPairForCloud?domainurl=${domainurl}&sub_skill=${sub_skill}`)
    let res = await axios.get(
      `/bot/api/w/${wId}/jira/generateRSAKeyPairForCloud?domainurl=${domainurl}&sub_skill=${sub_skill}`
    );

    return res.data;
  } catch (error) {
    return { success: false };
  }
}

export const getOauthTokensForCloud = async (wId, sessionId, from) => {
  try {
    // `from` (e.g. 'onboarding') is echoed into the OAuth callback URL so the
    // post-connect redirect can return the user to where they started.
    const q = from ? `?from=${encodeURIComponent(from)}` : '';
    let res = await axios.get(
      `/bot/api/w/${wId}/jira/generateOAuthTokensForCloud/${sessionId}${q}`
    );
    if (res.data.success) {
      // return res.data.url
      return res.data;
    } else {
      // return null
      return res.data;
    }
  } catch (error) {
    return { success: false };
  }
};

export const validateDomainUrl = async (wId, domainurl) => {
  try {
    // let res = await axios.get(`/bot/api/${wId}/validatedomainurl?domainurl=${domainurl}`)
    let res = await axios.get(
      `/bot/api/w/${wId}/jira/validatedomainurl?domainurl=${domainurl}`
    );
    if (res.data.success) {
      return res.data;
    } else {
      // return false
      return res.data;
    }
  } catch (error) {
    return false;
  }
};

export const getOauthTokensForCloudUsers = async (wId, sub_skill) => {
  try {
    // let res = await axios.get(`/bot/api/${wId}/generateOauthTokensForCloudUsers?sub_skill=${sub_skill}`)
    let res = await axios.get(
      `/bot/api/w/${wId}/jira/generateOauthTokensForCloudUsers?sub_skill=${sub_skill}`
    );
    if (res.data.success) {
      return res.data.url;
    } else return false;
  } catch (error) {
    return false;
  }
};

export const getGuestOauthTokensForCloudUsers = async (
  wId,
  sub_skill,
  queryParams
) => {
  try {
    let queryString = '';
    if (queryParams.view) queryString += `&view=${queryParams.view}`;
    if (queryParams.channel_id)
      queryString += `&channel_id=${queryParams.channel_id}`;
    if (queryParams.channel_name)
      queryString += `&channel_name=${queryParams.channel_name}`;
    if (queryParams.channel_type)
      queryString += `&channel_type=${queryParams.channel_type}`;

    // let res = await axios.get(`/bot/api/${wId}/guest/generateOauthTokensForCloudUsers?sub_skill=${sub_skill}${queryString}`)
    let res = await axios.get(
      `/bot/api/w/${wId}/jira/guest/generateOauthTokensForCloudUsers?sub_skill=${sub_skill}${queryString}`
    );
    if (res.data.success) {
      return res.data.url;
    } else return false;
  } catch (error) {
    return false;
  }
};

// guest facilitation authorize for OAuth 2.0 (jira_cloud) connections
export const getOauth2GuestConnectUrl = async (
  wId,
  sub_skill,
  channel_id,
  returnTo
) => {
  try {
    let res = await axios.get(
      `/bot/api/w/${wId}/jira/oauth2/guest/connectUrl`,
      {
        params: { sub_skill, channel_id, returnTo },
      }
    );
    if (res.data.success) {
      return res.data.url;
    } else return false;
  } catch (error) {
    return false;
  }
};
